var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from "path-shared/models/filter-data";
var CobrosFilter = /** @class */ (function (_super) {
    __extends(CobrosFilter, _super);
    function CobrosFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.fechas = null;
        _this.aparatos = null;
        _this.labels['fechas'] = _this.i18n('Dates');
        _this.labels['aparatos'] = _this.i18n('Aparells');
        return _this;
    }
    return CobrosFilter;
}(FilterData));
export { CobrosFilter };
